import axios, { AxiosInstance } from "axios";

function getRequestBaseURL(): string {
  const { host, protocol } = window.location;
  const hostName = host.replace("www.", "");
  if (host.startsWith("localhost")) {
    return "https://app.alphacat.app/api/v0";
  }
  return `${protocol}//app.${hostName}/api/v0`;
}

export default function getAxiosInstance(): AxiosInstance {
  return axios.create({
    baseURL: getRequestBaseURL(),
    timeout: 10000,
    withCredentials: true,
  });
}
